import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { theme } from '../../index'
import './OutlinedCard.css';

export default function OutlinedCard({title, body, array}) {
    return (
        <Card variant='plain' sx={{ width: '100%', height: '100%', backgroundColor: theme.palette.champagne.main}}>
                <React.Fragment>
                    {array?.length > 0 ? (
                        <CardContent sx={{padding: '10px 10px', height: '100%',display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                            <Typography variant="h5" component="div">
                                {title}
                            </Typography>
                            <ul>
                                {
                                    array.map((messageType, index) => {
                                        return (
                                            <li key={index}>
                                                <Typography variant="p" style={{display: 'flex', justifyContent: 'space-between'}} key={messageType.id}>
                                                    <span className='messageType' title={messageType.type}> {messageType.type}: </span><span> {messageType.number} </span>
                                                </Typography>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </CardContent>
                    ) : (
                        <CardContent sx={{padding: '10px 10px', height: '100%',display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly'}}>
                            <Typography variant="h5" component="div">
                                {title}
                            </Typography>
                            <Typography variant="h4" component="p">
                                {body}
                            </Typography>
                        </CardContent>
                    )}
                </React.Fragment>
            </Card>

    );
}